interface BreadcrumbItem {
  label: string;
  href: string;
}

interface SchemaOrgProps {
  type: 'website' | 'webpage' | 'organization' | 'article' | 'faq' | 'breadcrumb';
  pageTitle?: string;
  pageDescription?: string;
  pageUrl?: string;
  breadcrumbs?: BreadcrumbItem[];
  articleData?: {
    title: string;
    description: string;
    datePublished?: string;
    author?: string;
    imageUrl?: string;
  };
  faqData?: { question: string; answer: string }[];
}

export default function SchemaOrg({
  type,
  pageTitle,
  pageDescription,
  pageUrl = 'https://mogu.video',
  breadcrumbs,
  articleData,
  faqData,
}: SchemaOrgProps) {
  const getSchema = () => {
    const schemas: Record<string, unknown>[] = [];

    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '蘑菇视频',
      url: pageUrl,
      description: '蘑菇视频提供香蕉视频、糖心视频等中外影视资源点播，涵盖韩国电影、美国大片、最新电视剧、热播剧集、动漫番剧，高清免费在线观看。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-8888',
        contactType: 'customer service',
        email: 'contact@mogu.video',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '北京',
        addressRegion: '北京',
        addressCountry: 'CN',
        streetAddress: '北京市朝阳区建国路88号',
      },
    });

    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '蘑菇视频',
      url: pageUrl,
      description: '蘑菇视频 - 高清电影电视剧在线观看平台，提供韩国电影、美国大片、热播剧集、动漫番剧免费点播。',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${pageUrl}/search?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    });

    if (type === 'webpage' || pageTitle) {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: pageTitle || '蘑菇视频',
        description: pageDescription || '',
        url: pageUrl,
        isPartOf: {
          '@type': 'WebSite',
          name: '蘑菇视频',
          url: 'https://mogu.video',
        },
      });
    }

    if (breadcrumbs && breadcrumbs.length > 0) {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((crumb, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: crumb.label,
          item: `https://mogu.video${crumb.href}`,
        })),
      });
    }

    if (type === 'article' && articleData) {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: articleData.title,
        description: articleData.description,
        datePublished: articleData.datePublished || '2024-01-01',
        author: {
          '@type': 'Organization',
          name: articleData.author || '蘑菇视频',
        },
        image: articleData.imageUrl,
        publisher: {
          '@type': 'Organization',
          name: '蘑菇视频',
        },
      });
    }

    if (type === 'faq' && faqData) {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqData.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      });
    }

    return schemas;
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getSchema(), null, 2) }}
    />
  );
}